/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-danger */
import { ContentTypeData } from "@plinknz/tah-website-elements";
import * as React from "react";
import { FacebookFeed } from "./facebook";

export interface ContentProps {
  data: ContentTypeData;
}

export interface LinkRendererProps {
  href: string;
  children: React.ReactNode;
}

export const Content = ({ data: { facebookFeed, content } }: ContentProps) => (
  <>
    <div data-testid="content" className="content || constrain-width">
      {facebookFeed && <FacebookFeed />}
      <div dangerouslySetInnerHTML={{ __html: content }} />
      {facebookFeed && <FacebookFeed mobile />}
    </div>
  </>
);
